<!-- Gestão completa de categorias do cliente, reusada em modo embutido (contexto).
     Montada só quando a sub-aba abre (lazy) e re-montada ao trocar de cliente. -->
<app-grupo *ngIf="montado"
  [embutido]="true"
  [empresaContextoId]="clienteEmpresaId">
</app-grupo>
